import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  query IslamicMosques {
    allIslamicMosquesCsv(sort: {order: ASC, fields: english_name_I}) {
      edges {
        node {
          malay_name_I
          malay_name_II
          english_name_I
          english_name_II
					latitude
					longitude
          id
					established_year
					telephone_number
					full_address
          date_sketch_created
        }
      }
    }
  }
`

const useIslamicMosquesData = () => {
  let {
    allIslamicMosquesCsv: { edges }
  } = useStaticQuery(query)

  let data = edges.map(x => x.node)

  // Because Mosques don't have chinese name
  data = data.map(e => ({
    ...e,
    chinese_name_I: e.malay_name_I,
    chinese_name_II: e.malay_name_II,
  }))

  return data
}

export default useIslamicMosquesData
